import React, {useEffect, useMemo, useState} from 'react';
import DisposeTableItem from "../../../base/dispose-tab-item";

interface IComponentProps { 
  data?: any;
  enums?: any
}
const CarTagsItem: React.FC<IComponentProps> = (props) => {
  const { data, enums } = props
  const [ dataList, setDataList ] = useState<any[]>([])
  const enumMap = useMemo(() => {
    const res: any = {}
    enums.car_tag?.forEach((item: any) => {
      res[item.key] = item.value
    })
    return res
  }, [enums])

  useEffect(() => {
    const { tags } = data
    const list = tags?.split(',').map( (item: any)=> {
      return {
        tagText: enumMap[item]
      }
    })
    setDataList(list)
  }, [data, enums]);

  return (
    <>
      <DisposeTableItem dataList={dataList}></DisposeTableItem>
    </>
  );
};

export default CarTagsItem;
